import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Small = makeShortcode("Small");
const DateUpdated = makeShortcode("DateUpdated");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "uses",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#uses",
        "aria-label": "uses permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Uses`}</h2>
    <Small mdxType="Small">
  Last updated: <DateUpdated date={`2021-02-04`} small={`true`} mdxType="DateUpdated" />
    </Small>
    <p>{`All the equipment and tools I use on a daily basis.`}</p>
    <p>{`For home, I use Windows 10 Pro Insider Preview exclusively now.
Windows Subsystem for Linux (WSL) has come a long way with WSL2.`}</p>
    <p>{`If you are intersted in getting familiar with it check the `}<a parentName="p" {...{
        "href": "https://scottspence.com/tags/wsl/",
        "target": "_blank",
        "rel": "noopener"
      }}>{`tags
section for WSL`}</a>{`.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "uses-at-home",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#uses-at-home",
        "aria-label": "uses at home permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Uses at home`}</h3>
    <h3 {...{
      "id": "desk",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#desk",
        "aria-label": "desk permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Desk`}</h3>
    <ul>
      <li parentName="ul">{`My computer is a `}<a parentName="li" {...{
          "href": "https://uk.pcpartpicker.com/list/pHkrCL",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Ryzen 5 Mini ITX build`}</a>{`, my `}<a parentName="li" {...{
          "href": "https://scottspence.com/2020/05/30/first-time-pc-build/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`first time PC
building a PC`}</a>{`.`}</li>
      <li parentName="ul">{`Desk chair is a `}<a parentName="li" {...{
          "href": "https://amzn.to/2ZKWKQa",
          "target": "_blank",
          "rel": "noopener"
        }}>{`HÅG Capisco Puls`}</a></li>
      <li parentName="ul">{`I run two `}<a parentName="li" {...{
          "href": "https://amzn.to/2ZKVMUP",
          "target": "_blank",
          "rel": "noopener"
        }}>{`HP EliteDisplay’s E232 58,4 cm (23”)`}</a>{` Monitors through a
Dell 452-BBOO USB 3.0 Ultra HD Triple Video Docking Station.`}</li>
      <li parentName="ul">{`Keyboard is now a `}<a parentName="li" {...{
          "href": "https://www.logitechg.com/en-gb/products/gaming-keyboards/g915-tkl-wireless.html",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Logitech G915`}</a>{`, I `}<a parentName="li" {...{
          "href": "https://scottspence.com/2021/02/01/logitech-g915/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`made some notes`}</a>{` on it as
well.`}</li>
      <li parentName="ul">{`Microphone, a `}<a parentName="li" {...{
          "href": "https://amzn.to/2N1uDWK",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Fifine Usb Cardioid Studio Condenser Microphone`}</a>{`
which is surprisingly good quality for the price.`}</li>
    </ul>
    <h3 {...{
      "id": "os",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#os",
        "aria-label": "os permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`OS`}</h3>
    <p>{`I have been through many Linux distributions, currently I’m dual
booting Windows with Pop!`}{`_`}{`OS by System76`}</p>
    <h3 {...{
      "id": "editor--terminal",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#editor--terminal",
        "aria-label": "editor  terminal permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Editor + Terminal`}</h3>
    <ul>
      <li parentName="ul">{`Microsoft `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Visual Studio Code`}</a>{` with `}<a parentName="li" {...{
          "href": "https://github.com/sdras/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Sarah Drasner`}</a>{`’s awesome `}<a parentName="li" {...{
          "href": "https://github.com/sdras/night-owl-vscode-theme",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Night
Owl`}</a>{` 🦉 theme`}</li>
      <li parentName="ul">{`Terminal of choice is `}<a parentName="li" {...{
          "href": "https://www.microsoft.com/en-gb/p/windows-terminal/9n0dx20hk701",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Windows Terminal`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rubjo.github.io/victor-mono/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Victor Mono`}</a>{` font for both text editor and terminal.`}</li>
    </ul>
    <h3 {...{
      "id": "desktop-apps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#desktop-apps",
        "aria-label": "desktop apps permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Desktop Apps`}</h3>
    <ul>
      <li parentName="ul">{`I use OBS (`}<a parentName="li" {...{
          "href": "https://obsproject.com/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Open Broadcaster Software`}</a>{`) for recording some coding
sessions.`}</li>
      <li parentName="ul">{`For light video editing I use `}<a parentName="li" {...{
          "href": "https://shotcut.org/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Shotcut`}</a></li>
    </ul>
    <hr></hr>
    <h3 {...{
      "id": "uses-at-work",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#uses-at-work",
        "aria-label": "uses at work permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Uses at work`}</h3>
    <h3 {...{
      "id": "desk-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#desk-1",
        "aria-label": "desk 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Desk`}</h3>
    <ul>
      <li parentName="ul">{`My work computer is a i9 `}<a parentName="li" {...{
          "href": "https://amzn.to/30ZX76C",
          "target": "_blank",
          "rel": "noopener"
        }}>{`MackBook Pro (15-inch, 2019)`}</a></li>
    </ul>
    <h3 {...{
      "id": "editor--terminal-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#editor--terminal-1",
        "aria-label": "editor  terminal 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Editor + Terminal`}</h3>
    <ul>
      <li parentName="ul">{`Microsoft `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Visual Studio Code`}</a>{` with `}<a parentName="li" {...{
          "href": "https://github.com/sdras/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Sarah Drasner`}</a>{`’s awesome `}<a parentName="li" {...{
          "href": "https://github.com/sdras/night-owl-vscode-theme",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Night
Owl`}</a>{` 🦉 theme`}</li>
      <li parentName="ul">{`Hyper with Fish and Oh My Fish`}</li>
    </ul>
    <h3 {...{
      "id": "desktop-apps-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#desktop-apps-1",
        "aria-label": "desktop apps 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Desktop apps`}</h3>
    <ul>
      <li parentName="ul">{`For gif capture I use Kap.`}</li>
      <li parentName="ul">{`For installing any apps I’m using `}<a parentName="li" {...{
          "href": "https://cheatsheets.xyz/homebrew/",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Homebrew`}</a>{`.`}</li>
    </ul>
    {
      /* Links */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      